import {
    Component,
    ViewChild,
    TemplateRef,
    AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
// -- components --
import { SubTabsComponent } from '../components/sub-tabs/sub-tabs.component';
import { Step1Component } from './components/step-1/step-1.component';
import { Step2Component } from './components/step-2/step-2.component';
import { Step3Component } from './components/step-3/step-3.component';
// -- model --
import { TabOption } from '../components/sub-tabs/sub-tabs.component';
import { Jc3Service } from '../jc3.service';
import { ToastrService } from 'ngx-toastr';
import { TabNavigationHandlerService } from '../services/tab-navigation-handler.service';

@Component({
    selector: 'app-certification',
    standalone: true,
    imports: [
        CommonModule,
        SubTabsComponent,
        Step1Component,
        Step2Component,
        Step3Component,
    ],
    providers: [TabNavigationHandlerService],
    templateUrl: './certification.component.html',
    styleUrl: './certification.component.scss',
})
export class CertificationComponent implements AfterViewInit {
    tabs: TabOption[] = [];
    certificationsData: any[] = [];
    certData: any = [];
    certCards: any = [];
    stepData = [];

    @ViewChild('step1') step1!: TemplateRef<any>;
    @ViewChild('step2') step2!: TemplateRef<any>;
    @ViewChild('step3') step3!: TemplateRef<any>;

    constructor(
        private jc3Service: Jc3Service,
        private toastr: ToastrService,
        public tabHandler: TabNavigationHandlerService
    ) {}
    ngAfterViewInit() {
        this.tabHandler.initialize({
            mainTabName: 'certification',
            tabs: this.tabs,
        });
        this.getCertificationData();
        this.getCertificationCards();

        this.setupTabs();
    }

    private setupTabs(): void {
        if (!this.certData) return;

        this.tabs = [
            {
                label: this.certData.switcher1,
                value: 'MULTICERT',
                // value: this.certData?.switcher1alias?.toLowerCase(),
                template: this.step1,
            },
            {
                label: this.certData.switcher2,
                value: 'AGRI',
                // value: this.certData?.switcher2alias?.toLowerCase(),
                template: this.step2,
            },
            {
                label: this.certData.switcher3,
                value: 'BUILDS',
                // value: this.certData?.switcher3alias?.toLowerCase(),
                template: this.step3,
            },
        ];

        // Update tabs in the handler service
        this.tabHandler.updateTabs(this.tabs);
    }

    getCertificationData() {
        this.jc3Service.getCertificationTitleSwitcher().subscribe({
            next: (res) => {
                this.certData = res?.at(0);
            },
            error: (err) => {
                this.toastr.error(err.message);
            },
        });
    }
    getCertificationCards() {
        this.jc3Service.getCertificationCards().subscribe({
            next: (res) => {
                this.certCards = res;
                this.setupTabs();
                this.stepData[0] = this.getCardsForSwitcherGroup('MULTICERT');
                this.stepData[1] = this.getCardsForSwitcherGroup('AGRI');
                this.stepData[2] = this.getCardsForSwitcherGroup('BUILDS');
            },
            error: (err) => {
                this.toastr.error(err.message);
            },
        });
    }

    getCardsForSwitcherGroup(switcherGroup: string): any[] {
        if (!this.certCards) return [];

        const today = new Date();

        return this.certCards.filter((card) => {
            const publishDate = new Date(card.publishdate);
            return card.switchergroup === switcherGroup && publishDate <= today;
        });
    }

    ngOnDestroy(): void {
        this.tabHandler.ngOnDestroy();
    }
}
